import React, { useCallback, useRef, useState } from 'react';
import * as Yup from 'yup';
import { useHistory, Link } from 'react-router-dom';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import { IconArrowLeft } from '@tabler/icons';

import api from '../../services/api';
import { useToast } from '../../hooks/toast';
import getValidationErrors from '../../utils/getValidationErrors';

import Button from '../../components/Button';
import Input from '../../components/Form/Input';
import { H1, Text } from '../../components/Generic';
import { Container, TransparentButton } from './styles';

interface SignUpData {
  name: string;
  email: string;
  password: string;
  passwordConfirm: string;
}

const SignUp: React.FC = () => {
  const [loading, setLoading] = useState(false);

  const formRef = useRef<FormHandles>(null);
  const { addToast } = useToast();
  const history = useHistory();

  const handleSubmit = useCallback(
    async (data: SignUpData) => {
      try {
        setLoading(true);

        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          name: Yup.string().required('Nome obrigatório.'),
          email: Yup.string()
            .required('Email obrigatório.')
            .email('Informe um email válido.'),
          password: Yup.string().min(
            6,
            'A senha deve ter no mínimo 6 dígitos.',
          ),
          passwordConfirm: Yup.string().oneOf(
            [Yup.ref('password'), null],
            'As senhas devem corresponder.',
          ),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        await api.post('usuarios', {
          nome: data.name,
          email: data.email,
          senha: data.password,
        });

        history.push('/');

        addToast({
          type: 'success',
          title: 'Sucesso!',
          description: 'Sua conta foi criada, faça o login.',
        });
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);

          formRef.current?.setErrors(errors);
          return;
        }

        console.log(err);

        addToast({
          type: 'error',
          title: 'Erro!',
          description: err.response?.data?.message || 'Algo deu errado.',
        });
      } finally {
        setLoading(false);
      }
    },
    [addToast, history],
  );

  return (
    <Container>
      <div
        onClick={() => history.goBack()}
        style={{ marginBottom: 60, width: 30, cursor: 'pointer' }}
      >
        <IconArrowLeft size={30} color="#999" />
      </div>

      <H1 style={{ marginBottom: 20 }}>Cadastro</H1>
      <Text style={{ marginBottom: 40 }}>
        Crie a sua conta agora mesmo, é grátis.
      </Text>

      <Form style={{ marginTop: 20 }} ref={formRef} onSubmit={handleSubmit}>
        <Input label="Nome" name="name" placeholder="Ex.: João Silva" />
        <Input
          label="Email"
          name="email"
          type="email"
          placeholder="exemplo@email.com"
        />
        <Input label="Senha" name="password" type="password" />
        <Input
          label="Confirme a senha"
          name="passwordConfirm"
          type="password"
        />

        <Button isLoading={loading} style={{ marginTop: 60 }} type="submit">
          Enviar
        </Button>

        <Link to="/login">
          <TransparentButton>
            Já tem uma conta?<b>Faça o login</b>
          </TransparentButton>
        </Link>
      </Form>
    </Container>
  );
};

export default SignUp;
